import { createBrowserRouter, Navigate } from "react-router-dom";
import AddOrEditProductPage from "../components/admin/AddOrEditProductPage";
import AdminDashboard from "../components/admin/AdminDashboard";
import ResponsiveAdminInventory from "../components/product/ResponsiveAdminInventory";
import PrivateRoute from "../components/PrivateRoute";
import PublicRoute from "../components/PublicRoute";
import AdminHeader from "../pages/AdminHeader";
import AddOrEditCollectionPage from "../pages/AddOrEditCollectionPage";
import CategoriesManagement from "../pages/CategoriesManagement";
import CategoryProductsPage from "../pages/CategoryProductsPage";
import CollectionsManagement from "../pages/CollectionsManagement";
import CreateLinkPage from "../pages/CreateLinkPage";
import Customers from "../pages/Customers";
import DeliveryChargesManagement from "../pages/DeliveryChargesManagement";
import { LoginPage } from "../pages/LoginPage";
import { OnboardingPage } from "../pages/OnboardingPage";
import OrderManagement from "../pages/OrdersManagement";
import OrderDetail from "../pages/OrderDetail";
import PaymentMethods from "../pages/PaymentMethods";
import Settings from "../pages/Settings";
import ShippingPartnersManagement from "../pages/ShippingPartnersManagement";
import StoreConfig from "../pages/StoreConfig";
import NotificationsPage from "../pages/NotificationsPage";
import CouponsManagement from "../pages/CouponsManagement";
import AgentWorkspacePage from "../pages/AgentWorkspacePage";
import TokenPurchasePage from "../pages/TokenPurchasePage";
import PurchaseConfirmationPage from "../pages/PurchaseConfirmationPage";
import BillingPage from "../pages/BillingPage";
import BillPaymentConfirmation from "../pages/BillPaymentConfirmation";
import AutoDmPage from "../pages/AutoDmPage";
import InstagramAuthCallbackPage from "../pages/InstagramAuthCallbackPage";
import ReportsPage from "../pages/ReportsPage";
import LabelDownload from "../pages/LabelDownload";
import IntegrationsPage from "../pages/IntegrationsPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicRoute><LoginPage /></PublicRoute>,
  },
  {
    element: <PrivateRoute />,
    children: [
      { path: "onboarding", element: <OnboardingPage /> },
      { path: "agent", element: <AgentWorkspacePage /> },
      { path: "tokens/purchase", element: <TokenPurchasePage /> },
      { path: "tokens/confirmation", element: <PurchaseConfirmationPage /> },
      {
        element: <AdminHeader />,
        children: [
          { path: "dashboard", element: <AdminDashboard /> },
          { path: "products", element: <ResponsiveAdminInventory /> },
          { path: "add-product", element: <AddOrEditProductPage /> },
          { path: "orders", element: <OrderManagement /> },
          { path: "orders/:orderId", element: <OrderDetail /> },
          { path: "customers", element: <Customers /> },
          { path: "collections", element: <CollectionsManagement /> },
          { path: "collections/add", element: <AddOrEditCollectionPage /> },
          { path: "collections/edit/:collectionId", element: <AddOrEditCollectionPage /> },
          { path: "categories", element: <CategoriesManagement /> },
          { path: "categories/:categoryId/products", element: <CategoryProductsPage /> },
          { path: "create-link", element: <CreateLinkPage /> },
          { path: "store", element: <StoreConfig /> },
          { path: "notifications", element: <NotificationsPage /> },
          { path: "coupons", element: <CouponsManagement /> },
          { path: "settings", element: <Settings /> },
          { path: "integrations", element: <IntegrationsPage /> },
          { path: "payments", element: <PaymentMethods /> },
          { path: "billing", element: <BillingPage /> },
          { path: "billing/confirm/:billId", element: <BillPaymentConfirmation /> },
          { path: "reports", element: <ReportsPage /> },
          { path: "auto-dm", element: <AutoDmPage /> },
          { path: "auto-dm/callback", element: <InstagramAuthCallbackPage /> },
          { path: "delivery-charges", element: <DeliveryChargesManagement /> },
          { path: "shipping-partners", element: <ShippingPartnersManagement /> },
          { path: "label-download", element: <LabelDownload /> },
        ]
      }
    ]
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);

export default router;
